
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"74","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.271 7.642c-.042 3.33 2.966 5.188 5.233 6.293 2.329 1.133 3.111 1.86 3.102 2.874-.018 1.551-1.858 2.236-3.58 2.263-3.004.046-4.75-.812-6.14-1.46l-1.082 5.065c1.394.643 3.974 1.203 6.649 1.227 6.28 0 10.388-3.1 10.41-7.909.025-6.101-8.437-6.44-8.379-9.167.02-.826.809-1.709 2.538-1.933.855-.114 3.217-.2 5.895 1.033l1.05-4.901C52.529.502 50.678 0 48.374 0 42.462 0 38.304 3.143 38.27 7.642zM64.067.422c-1.146 0-2.113.67-2.544 1.696l-8.97 21.426h6.275l1.248-3.452h7.669l.724 3.452H74L69.174.422h-5.107zm.878 6.246l1.811 8.683h-4.96l3.149-8.683zM30.663.422l-4.947 23.122h5.98L36.64.422h-5.977zm-8.846 0L15.592 16.16 13.075 2.778C12.779 1.285 11.613.422 10.317.422H.142L0 1.094c2.089.453 4.462 1.184 5.9 1.967.88.478 1.13.896 1.42 2.031l4.768 18.452h6.32L28.096.422h-6.28z","fill":"url(#paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"34.021","y1":"24.384","x2":"34.713","y2":"-.166","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#222357"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#254AA5"}})])])])
          )
        }
      }
    